export default __webpack_public_path__ + "static/image-58-f350f33e6dd813e9681be634c8af0249.jpg";